<template>
  <div class="mt90">
    <el-row style="background:#f3f3f3;height:1px"></el-row>
    <el-row class="model-art-detail pr-container bg-white pb-6">
      <!-- <h4 class="text-center font26 f-w500 mt-6 mb-0" :class="[$store.state.titleColors[article.titleColour || 0]]">{{article.title}}</h4> -->
      <h4 class="h-article-color-green text-center f-w500 font26 mt-6 mb-0">{{article.title}}</h4>
      <p class="text-center font16 col999 m-1">{{ article.createDate ? article.createDate : '' | date }}</p>
      <section class="my-5" v-html="article.content"></section>
    </el-row>
  </div>
</template>

<script>
import Qs from 'qs'

export default {
  name: "IndustryInformationDetails",
  data() {
    return {
      article: null,
    };
  },
  created() {
    this.getArticle();
  },
  watch: {
    $route: "getArticle"
  },
  methods: {
    getArticle() {
      this.axios.get('/protal/article/article/'+this.$route.params.id)
        .then(res => {
          if(res.data.code == 200) {
            this.article = res.data.data;
            // window.document.title = this.article.title + this.$store.state.webTitleSuffix;
          }
        });
    }
  }
};
</script>

<style lang="scss">
  $lineCol: #dee0cc;
  $fontCol: #333;
  
</style>
